import { createContext, useContext, useState, useCallback } from "react";
import { ConfirmDialog } from "../components/common/ConfirmDialog";

const ConfirmContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error("useConfirm must be used within a ConfirmProvider");
  }
  return context;
};

export const ConfirmProvider = ({ children }) => {
  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    title: "",
    message: "",
    confirmLabel: "Confirm",
    cancelLabel: "Cancel",
    color: "primary",
    resolve: null,
  });

  const confirm = useCallback((config = {}) => {
    return new Promise((resolve) => {
      setDialogConfig({
        open: true,
        title: config.title || "Confirm Action",
        message: config.message || "Are you sure you want to proceed?",
        confirmLabel: config.confirmLabel || "Confirm",
        cancelLabel: config.cancelLabel || "Cancel",
        color: config.color || "primary",
        resolve,
      });
    });
  }, []);

  const handleConfirm = () => {
    if (dialogConfig.resolve) {
      dialogConfig.resolve(true);
    }
    setDialogConfig((prev) => ({ ...prev, open: false, resolve: null }));
  };

  const handleCancel = () => {
    if (dialogConfig.resolve) {
      dialogConfig.resolve(false);
    }
    setDialogConfig((prev) => ({ ...prev, open: false, resolve: null }));
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmDialog
        open={dialogConfig.open}
        title={dialogConfig.title}
        message={dialogConfig.message}
        confirmLabel={dialogConfig.confirmLabel}
        cancelLabel={dialogConfig.cancelLabel}
        color={dialogConfig.color}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </ConfirmContext.Provider>
  );
};
